// GENERATED FILE — do not edit. Source of truth: contracts/. Regenerate: node scripts/sync-contracts.mjs

import { api } from '../apiClient';

import { z } from 'zod';
// Runtime validation: every named type above has a matching `<Name>Schema` zod export — the
// exact schema the backend validates with (story 2-92), so forms can `.parse()`/`.safeParse()`
// against it instead of hand-rolling checks. `.refine()` cross-field rules are preserved
// verbatim; the refine() error MESSAGE is not — the server owns user-facing text.

export type ComparePlan = {
  slug: string;
  name: string;
  priceMonthly?: number | null | undefined;
  isCustom: boolean;
  entitlements: Array<string>;
};
export const ComparePlanSchema = z.object({
  slug: z.string(),
  name: z.string(),
  priceMonthly: z.number().nullable().optional(),
  isCustom: z.boolean(),
  entitlements: z.array(z.string()),
}).strict();

export type CompareFeature = {
  key: string;
  name: string;
  category: string;
};
export const CompareFeatureSchema = z.object({
  key: z.string(),
  name: z.string(),
  category: z.string(),
}).strict();

export type GetPlanComparisonResponse = {
  plans: Array<ComparePlan>;
  features: Array<CompareFeature>;
};

export async function getPlanComparison(): Promise<GetPlanComparisonResponse> {
  const response = await api.get<GetPlanComparisonResponse>(`/plans/compare`);
  return response.data;
}

export const plansKeys = {
  all: ["plans"] as const,
  lists: () => [...plansKeys.all, 'list'] as const,
  list: (filters?: Record<string, unknown>) =>
    [...plansKeys.lists(), ...(filters ? [filters] : [])] as const,
  details: () => [...plansKeys.all, 'detail'] as const,
  detail: (id: string) => [...plansKeys.details(), id] as const,
};
